import React from 'react'
import Barathivizha from './Barathivizha'

const Events = () => {
  return (
    <div>
      <Barathivizha />
    </div>
  )
}

export default Events